import * as React from 'react';
import { colorText, ContentPopup, HeaderPopup, MainText, WrapperPopup } from 'styles';

export interface IWindowUnit {
    x: number;
    y: number;
    mode: 'free' | 'group';
    closeCB?: Function;
    children?: any;
    keyID?: string;
    headerText?: string;
}

const testArr: IWindowUnit[] = [
    {
        x: 100,
        y: 100,
        mode: 'free'
    },
    {
        x: 200,
        y: 200,
        mode: 'free'
    },
    {
        x: 300,
        y: 300,
        mode: 'group'
    },
    {
        x: 400,
        y: 400,
        mode: 'free'
    }
];

interface IPropsWindowUnit {
    x: number;
    y: number;
}

const WindowUnit: React.FC<IPropsWindowUnit> = ({ x = 0, y = 0 }) => {
    return (
        <div
            style={{
                minHeight: '50px',
                width: '50px',
                left: x + 'px',
                top: y + 'px',
                background: '#ccc',
                position: 'absolute'
            }}
            draggable="true">
            <div></div>
            <div></div>
        </div>
    );
};

interface IContextProps {
    createWindowUnit: (wnd: IWindowUnit) => void;
    closeWindowUnit: (wnd: IWindowUnit) => void;
    registrationDA: (id: string, funcAdd: Function, activatedArea: Function) => boolean;
}

export const WindowGlobalAreaContext = React.createContext({} as IContextProps);

const WindowGlobalArea: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    let [arrWindowUnit, setArrWindowUnit] = React.useState<IWindowUnit[]>([]);
    let [selectWindowUnit, setSelectWindowUnit] = React.useState({
        xMouseDown: 0,
        yMouseDown: 0,
        xPositUnit: 0,
        yPositUnit: 0,
        mouseDown: false
    });
    let [mapDistrArea, setMapDistrArea] = React.useState(new Map());
    let [selRef, setSelRef] = React.useState<HTMLElement | null>(null);
    let [activatedArea, setActivatedArea] = React.useState<any>(undefined);

    const createWindowUnit = (wnd: IWindowUnit) => {
        setArrWindowUnit((prevWindowUnits) => [...prevWindowUnits, wnd]);
    };

    const closeWindowUnit = (wnd: IWindowUnit) => {
        setArrWindowUnit((prevWindowUnits) => prevWindowUnits.filter((windowUnit) => windowUnit !== wnd));
    };
    const moveWindowUnit = (e: React.MouseEvent) => {
        if (selectWindowUnit.mouseDown) {
            //let tempArr = arrWindowUnit.slice();
            //tempArr[tempArr.length - 1].x = selectWindowUnit.xPositUnit + (e.clientX - selectWindowUnit.xMouseDown);
            //tempArr[tempArr.length - 1].y = selectWindowUnit.yPositUnit + (e.clientY - selectWindowUnit.yMouseDown);
            //setArrWindowUnit(tempArr)
            selRef!.style.left = selectWindowUnit.xPositUnit + (e.clientX - selectWindowUnit.xMouseDown) + 'px';
            selRef!.style.top = selectWindowUnit.yPositUnit + (e.clientY - selectWindowUnit.yMouseDown) + 'px';
            selRef!.style.opacity = '0.6';
        }
        if (selectWindowUnit.mouseDown) {
            let allElementsFromPoint = (x: any, y: any) => {
                let element: any;
                let elements: any[] = [];
                let old_visibility = [];
                let diveLevel = 4;
                let diveCount = 0;
                while (diveLevel > diveCount) {
                    element = document.elementFromPoint(x, y);
                    if (!element || element.id === 'root') {
                        break;
                    }
                    elements.push(element);
                    old_visibility.push(element.style.visibility);
                    element.style.visibility = 'hidden'; // Temporarily hide the element (without changing the layout)
                    diveCount++;
                }
                for (let k = 0; k < elements.length; k++) {
                    elements[k].style!.visibility = old_visibility[k];
                }
                return elements;
            };
            let elems = allElementsFromPoint(e.clientX, e.clientY);
            let fromArea = false;
            for (let key = 0; key < elems.length; key++) {
                if (elems[key].hasAttribute('id')) {
                    if (mapDistrArea.has(elems[key].getAttribute('id'))) {
                        let area = mapDistrArea.get(elems[key].getAttribute('id'));
                        area.activatedArea(true);
                        setActivatedArea(area);
                        fromArea = true;
                        break;
                    }
                }
            }
            if (!fromArea) {
                activatedArea && activatedArea.activatedArea(false);
                setActivatedArea(undefined);
            }
        }
    };
    const stopWindowUnit = (e: React.MouseEvent) => {
        if (selectWindowUnit.mouseDown) {
            let tempArr = arrWindowUnit.slice();
            tempArr[tempArr.length - 1].x = selectWindowUnit.xPositUnit + (e.clientX - selectWindowUnit.xMouseDown);
            tempArr[tempArr.length - 1].y = selectWindowUnit.yPositUnit + (e.clientY - selectWindowUnit.yMouseDown);
            setArrWindowUnit(tempArr);
            selectWindowUnit.mouseDown = false;
            setSelectWindowUnit(Object.assign({}, selectWindowUnit));
            selRef!.style.opacity = '';
            activatedArea && activatedArea.activatedArea(false);
            setActivatedArea(undefined);
        }
    };
    const popupWindowUnit = (e: React.MouseEvent, unit: any, indx: any) => {
        let tempArr = arrWindowUnit.slice();
        if (indx + 1 !== arrWindowUnit.length) {
            tempArr.splice(indx, 1);
            tempArr.push(unit);
        }
        setArrWindowUnit(tempArr);
        setSelectWindowUnit({
            mouseDown: true,
            xMouseDown: e.clientX,
            yMouseDown: e.clientY,
            xPositUnit: unit.x,
            yPositUnit: unit.y
        });
        setSelRef(e.currentTarget.parentElement);
    };
    const entryToArea = (e: React.MouseEvent) => {
        if (selectWindowUnit.mouseDown) {
            console.log(e.type);
        }
    };
    const registrationDA = (id: string, funcAdd: Function, activatedArea: Function) => {
        mapDistrArea.set('DistributionArea' + id, { funcAdd, activatedArea });
        return true;
    };

    return (
        <WindowGlobalAreaContext.Provider value={{ createWindowUnit, closeWindowUnit, registrationDA }}>
            <div
                style={{ width: '100%', height: '100%' }}
                onMouseMove={(e: React.MouseEvent) => moveWindowUnit(e)}
                onMouseUp={(e) => {
                    stopWindowUnit(e);
                }}>
                {children}
                {arrWindowUnit.map((unit, indx) => {
                    return (
                        <WrapperPopup
                            style={{
                                left: unit.x + 'px',
                                top: unit.y + 'px',
                                position: 'absolute'
                            }}
                            key={unit.keyID}>
                            <HeaderPopup
                                style={{ minWidth: '50px', marginBottom: '4px' }}
                                draggable={unit.mode === 'group' ? true : false}
                                onMouseDown={(e: React.MouseEvent) => {
                                    popupWindowUnit(e, unit, indx);
                                }}>
                                <MainText size={14} weight={'M'} color={colorText.header}>
                                    {unit.headerText}
                                </MainText>
                            </HeaderPopup>
                            <ContentPopup>{unit.children}</ContentPopup>
                        </WrapperPopup>
                    );
                })}
            </div>
        </WindowGlobalAreaContext.Provider>
    );
};

export default WindowGlobalArea;

interface IPropsDistributionArea {
    id: string;
}

export const DistributionArea: React.FC<IPropsDistributionArea> = ({ id }) => {
    let [content, setContent] = React.useState(<div>test1</div>);
    let [regOk, setRegOk] = React.useState(false);
    let [activatedArea, setActivatedArea] = React.useState(false);

    const { registrationDA } = React.useContext(WindowGlobalAreaContext);

    if (!regOk) {
        let res = registrationDA(
            id,
            (elem: any) => setContent(elem),
            (val: any) => {
                setActivatedArea(val);
            }
        );
        setRegOk(res);
    }

    if (activatedArea) {
        return (
            <div
                id={'DistributionArea' + id}
                style={{
                    width: '100%',
                    height: '100%',
                    background: '#ccc',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                <div style={{ width: '50px', height: '50px', background: '#fff' }}>Top</div>
                <div style={{ width: '50px', height: '50px', background: '#fff' }}>Rigth</div>
                <div style={{ width: '50px', height: '50px', background: '#fff' }}>Left</div>
                <div style={{ width: '50px', height: '50px', background: '#fff' }}>Bottom</div>
            </div>
        );
    } else {
        return (
            <div id={'DistributionArea' + id} style={{ width: '100%', height: '100%' }}>
                {content}
            </div>
        );
    }
};
